import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { MemberClientBranch } from "@/data/models/Branch";

const name = "branches";

@Module({ dynamic: true, namespaced: true, store, name: name })
export class BranchesVuexModule extends VuexModule {
  branchesOfGroup: MemberClientBranch[] = [];

  @Mutation
  setBranchesOfGroup(branches: MemberClientBranch[]) {
    this.branchesOfGroup = branches;
  }

  @Mutation
  clear() {
    this.branchesOfGroup = [];
  }
}

export const BranchesModule = getModule(BranchesVuexModule, store);
